import { Injectable } from '@angular/core';

import { ClaimFacade, SpecialRoutingService } from '@domgen/data-access-claims';
import { Observable, of, throwError } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { Claim } from '@domgen/dgx-components';

@Injectable({
  providedIn: 'root',
})
export class RepairDetailsGuard {
  constructor(private cf: ClaimFacade, private sr: SpecialRoutingService) {}

  canActivate(): Observable<boolean> {
    return this.checkClaim().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkClaim(): Observable<boolean> {
    return this.cf.activeClaim$.pipe(
      switchMap((claim: Claim) => {
        if (claim?.complete) {
          this.sr.routeToPlanDetails(claim);
          return throwError(false);
        } else {
          return of(true);
        }
      })
    );
  }
}
